<script lang="ts">
  import RepositoryFactory, { CONTRACT } from '../../repositories/RepositoryFactory';
  import { loginUser } from '../../components/auth/LoginUser';
  import Loading from '../loader.svelte';
  import type { GetContractResult } from '../../repositories/contract';
  import { getContext } from 'svelte';
  import { format, isAfter } from 'date-fns';

  const accountId = $loginUser.accountId;
  const suspendReasonCode = 'APPLIED';
  const { close }: any = getContext('simple-modal');
  let contract: GetContractResult;
  let isComplete = false;
  let promise = getContract();
  let statusName: '' | '解約済み' | '一時停止中' = '';

  async function getContract() {
    const contractRepository = RepositoryFactory[CONTRACT];
    return contractRepository
      .getContract()
      .then((res) => {
        contract = res;
        return res;
      })
      .catch((error) => {
        if (error.response.status === 403) {
          alert('セッションが切れました。再度ログインしてください。');
          loginUser.logout();
          location.reload();
        } else {
          alert('エラーが発生しました。');
          closeModal();
        }
      });
  }

  function doSuspend() {
    if (contract.contractStatusCode === 'TERMINATED' || contract.contractStatusCode === 'SUSPEND') {
      statusName = contract.contractStatusCode === 'TERMINATED' ? '解約済み' : '一時停止中';

      alert('現在の契約ステータスでは停止処理をすることができません。\nステータス：' + statusName);
      return false;
    }

    var currentDate = new Date();
    if (
      contract.suspendReopenDatetime &&
      isAfter(new Date(contract.suspendReopenDatetime), currentDate.setHours(currentDate.getHours() - 3))
    ) {
      alert('再開処理実行中のため、一時停止処理はしばらくたってから実行ください');
      return false;
    }

    const contractRepository = RepositoryFactory[CONTRACT];

    if (isUmobiled()) {
      contractRepository
        .suspend({ accountId, suspendReasonCode })
        .then((res) => {
          isComplete = true;
        })
        .catch((error) => {
          if (error.response.status === 403) {
            alert('セッションが切れました。再度ログインしてください。');
            loginUser.logout();
            location.reload();
          } else {
            alert('ただ今処理中のため時間がたってから再度実行ください');
            closeModal();
          }
        });
    } else {
      contractRepository
        .suspendPremium({ accountId, suspendReasonCode })
        .then((res) => {
          isComplete = true;
        })
        .catch((error) => {
          if (error.response.status === 403) {
            alert('セッションが切れました。再度ログインしてください。');
            loginUser.logout();
            location.reload();
          } else {
            alert('ただ今処理中のため時間がたってから再度実行ください');
            closeModal();
          }
        });
    }
  }

  function doReopen() {
    if (
      contract.contractStatusCode === 'TERMINATED' ||
      (contract.contractStatusCode === 'SUSPEND' && contract.suspendReasonCode !== 'APPLIED')
    ) {
      statusName = contract.contractStatusCode === 'TERMINATED' ? '解約済み' : '一時停止中';
      alert('現在の契約ステータスでは再開処理をすることができません。\nステータス：' + statusName);
      return false;
    }

    var currentDate = new Date();
    if (isAfter(new Date(contract.suspendDatetime), currentDate.setHours(currentDate.getHours() - 3))) {
      alert('一時停止処理実行中のため、再開処理はしばらくたってから実行ください');
      return false;
    }

    const contractRepository = RepositoryFactory[CONTRACT];

    if (isUmobiled()) {
      contractRepository
        .reopen({ accountId })
        .then((res) => {
          isComplete = true;
        })
        .catch((error) => {
          if (error.response.status === 403) {
            alert('セッションが切れました。再度ログインしてください。');
            loginUser.logout();
            location.reload();
          } else {
            alert('ただ今処理中のため時間がたってから再度実行ください');
            closeModal();
          }
        });
    } else {
      contractRepository
        .reopenPremium({ accountId })
        .then((res) => {
          isComplete = true;
        })
        .catch((error) => {
          if (error.response.status === 403) {
            alert('セッションが切れました。再度ログインしてください。');
            loginUser.logout();
            location.reload();
          } else {
            alert('ただ今処理中のため時間がたってから再度実行ください');
            closeModal();
          }
        });
    }
  }

  function closeModal() {
    if (isComplete) {
      location.reload();
    } else {
      close();
    }
  }

  const isUmobiled = () => {
    return $loginUser?.businessCode === 'UMOBILE_D' || $loginUser?.businessCode === 'UMOBILE_D_ENECOM';
  };
</script>

<div class="h-auto p-8 bg-white w-full m-auto">
  <div class="flex justify-between mb-10">
    <div class=" text-gray-700">
      <h1 class="text-2xl font-bold">SIM利用停止/再開</h1>
    </div>
  </div>

  {#await promise}
    <Loading />
  {:then}
    <div class="shadow rounded bg-gray-50 border-t-4 border-green-400">
      {#if contract.contractStatusCode === 'SUSPEND'}
        <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
          <div class="flex flex-col">
            {#if !isComplete}
              <div class="text-center min-w-full mb-6">SIMの利用を再開します。</div>

              <div class="flex-1 mb-10">
                <div class="justify-items-center text-center min-w-full">
                  停止日：
                  {format(new Date(contract.suspendDatetime), 'yyyy/MM/dd')}
                </div>
              </div>
            {:else}
              <div class="flex-1 mb-10">
                <div class="justify-items-center text-center min-w-full">再開処理を受け付けました。</div>
              </div>
            {/if}

            <div class="flex-1">
              <div class="flex flex-col justify-items-center items-center">
                <div class="flex-1 flex-col md:flex-row flex justify-items-center items-center">
                  <button class="button-close mb-5" on:click={() => close()}>閉じる</button>
                  {#if !isComplete}
                    <button class="button-request md:ml-5 mb-5" on:click|once={() => doReopen()}> OK </button>
                  {/if}
                </div>
              </div>
            </div>
          </div>
        </div>
      {:else}
        <div class="shadow rounded-lg bg-gray-50 border-1 p-4">
          <div class="flex flex-col">
            {#if !isComplete}
              <div class="items-center min-w-full mb-10">
                SIMの利用を停止します。<br />
                ※停止期間中も月額利用料等の費用は掛かる点をご留意ください。
              </div>
            {:else}
              <div class="items-center min-w-full mb-10">
                停止処理を受け付けました。<br />
                ※実際に利用停止するまで一定時間掛かります。
              </div>
            {/if}

            <div class="flex-1">
              <div class="flex flex-col justify-items-center items-center">
                <div class="flex-1 flex-col md:flex-row flex justify-items-center items-center">
                  <button class="button-close mb-5" on:click={() => close()}>閉じる</button>
                  {#if !isComplete}
                    <button class="button-request md:ml-5 mb-5" on:click|once={() => doSuspend()}> OK </button>
                  {/if}
                </div>
              </div>
            </div>
          </div>
        </div>
      {/if}
    </div>
  {/await}
</div>

<style lang="postcss">
  .button-close {
    @apply bg-gray-300 rounded hover:bg-gray-400 text-gray-500 focus:outline-none px-14 py-2;
  }
  .button-request {
    @apply bg-green-400 rounded hover:bg-green-500 text-white focus:outline-none px-14 py-2;
  }
  .button-request:disabled {
    @apply opacity-30 cursor-default;
  }
</style>
